module.exports = __webpack_public_path__ + "static/media/wqu_foundations_logo.2428b18c.png";